/** External dependencies */
import { Alert, Button, Collapse, Dropdown, Modal, Scrollspy, Tab, Toast } from 'bootstrap';

/** Internal dependencies */
import { defineScrollbarWidth, setHeaderHeight, throttle } from './utilities';

// add `Tab` if you need ws forms paging/tabs > it assumes Tab bound to the window.bootstrap object
window.bootstrap = { Toast, Tab };

window.bootstrapDetectBreakpoint = function () {
    const breakpointNames = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
    let breakpointValues = [];

    for (const breakpointName of breakpointNames) {
        breakpointValues[breakpointName] = window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--bs-breakpoint-' + breakpointName);
    }

    let i = breakpointNames.length;
    for (const breakpointName of breakpointNames) {
        i--;
        if (window.matchMedia('(min-width: ' + breakpointValues[breakpointName] + ')').matches) {
            return breakpointName;
        }
    }

    return null;
};

window.getBootstrapBreakpointWidth = function () {
    const breakpointNames = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
    let breakpointValues = [];

    for (const breakpointName of breakpointNames) {
        breakpointValues[breakpointName] = window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--bs-breakpoint-' + breakpointName);
    }

    let i = breakpointNames.length;
    let prevSize = breakpointValues['xxl'];

    for (const breakpointName of breakpointNames) {
        i--;

        if (window.matchMedia('(min-width: ' + breakpointValues[breakpointName] + ')').matches) {
            return parseInt(prevSize.substr(0, prevSize.length - 2));
        }

        prevSize = breakpointValues[breakpointName];
    }

    return null;
};

if (document.readyState !== 'loading') {
    initTheme();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initTheme();
    });
}

function initTheme() {
    document.documentElement.style.setProperty(
        '--scrollbar-width',
        window.innerWidth - document.documentElement.clientWidth + 'px'
    );

    throttle('resize', 'optimizedResize');
    window.addEventListener('optimizedResize', defineScrollbarWidth);
    defineScrollbarWidth();
    window.addEventListener('optimizedResize', setHeaderHeight);
    setHeaderHeight();
}

// wsform multi language
if (typeof jQuery !== 'undefined') {
    jQuery(function ($) {
        $(document).on('wsf-rendered', function (e, form, form_id, instance_id) {
            lazyLoadInstance.update();
            const wsForm = document.querySelector(`.wsf-form[data-id="${form_id}"]`);
            const wsfLang = document.createElement('input');
            wsfLang.type = 'hidden';
            wsfLang.name = 'lang';
            wsfLang.value = wsForm.getAttribute('data-ct-language');
            wsForm.appendChild(wsfLang);

            window.audioPlayers = [];
            window.audioInProgress = false;

            $('[data-audio]').each(function (index) {
                var element = $(this);
                window.audioPlayers.push(new Audio(element.attr('data-audio')));
                $(element.find('svg')).on('click', function () {
                    if (!window.audioInProgress) {
                        if (element.hasClass('playing')) {
                            window.audioPlayers[index].pause();
                            element.removeClass('playing');
                            window.audioInProgress = true;
                            setTimeout(function () {
                                window.audioInProgress = false;
                            }, 100);
                        } else {
                            $('[data-audio]').removeClass('playing');
                            $.each(window.audioPlayers, function (index) {
                                window.audioPlayers[index].pause();
                            });

                            window.audioPlayers[index].play();
                            element.addClass('playing');
                            window.audioInProgress = true;
                            setTimeout(function () {
                                window.audioInProgress = false;
                            }, 100);
                        }
                    }
                });

                window.audioPlayers[index].onended = function () {
                    element.removeClass('playing');
                };
            });
        });
    });

    jQuery(function ($) {
        $(document).ready(function () {
            $('.ct_petvideo').on('click', '.like, .likes', function (e) {
                e.preventDefault();
                if (!$(this).attr('isclicked')) {
                    let element = $(this);

                    element.attr('isclicked', true);
                    setTimeout(function () {
                        element[0].removeAttribute('isclicked');
                    }, 500);

                    const nonce = document.body.dataset.ctRestNonce;
                    const ctGuid = document.body.dataset.ctRestGuid;
                    const parentElement = element[0].classList.contains('likes')
                        ? element[0].parentElement
                        : element[0];
                    const cfTurnstileResponse = parentElement.querySelector('[name="cf-turnstile-response"]')?.value;
                    $.ajax({
                        type: 'POST',
                        url: $(this).attr('href'),
                        data: {
                            _wpnonce: nonce,
                            _ctguid: ctGuid,
                            _cfturnstileresponse: cfTurnstileResponse,
                        },
                        context: document.body,
                        success: function (data, status, xhttp) {
                            if (parseInt(data) === 1) {
                                element.closest('.tools').find('.like').addClass('voted');
                                let countelement = element.closest('.tools').find('[data-count]');
                                if (countelement) {
                                    countelement.text(parseInt(countelement.attr('data-count')) + 1);
                                }
                            }

                            if (!$('body').hasClass('has-vote')) {
                                Fancybox.fromOpener('#btn-newsletter', {
                                    startIndex: 1,
                                });
                                $('body').addClass('has-vote');
                            }
                        },
                    });
                }
            });
        });
    });

    jQuery(function ($) {
        $(document).ready(function () {
            $('.ct_petvideo').on('click', 'video', function (e) {
                e.preventDefault();
                let videoContainer = $(this).closest('.video');
                let videoElement = videoContainer.find('video');
                var videoPlayer = videoElement[0];
                if (!videoContainer.hasClass('started')) {
                    videoContainer.addClass('started');
                }

                if (videoContainer.hasClass('playing')) {
                    videoPlayer.removeAttribute('controls');
                    videoPlayer.pause();
                    videoContainer.removeClass('playing');
                } else {
                    videoPlayer.setAttribute('controls', '');
                    videoPlayer.play();
                    videoContainer.addClass('playing');
                }

                videoElement.bind('play', function () {
                    videoPlayer.setAttribute('controls', '');
                    videoPlayer.play();
                    videoContainer.addClass('playing');
                });

                videoElement.bind('pause', function () {
                    videoPlayer.removeAttribute('controls');
                    videoPlayer.pause();
                    videoContainer.removeClass('playing');
                });

                videoElement.bind('ended', function () {
                    videoPlayer.removeAttribute('controls');
                    videoPlayer.pause();
                    videoContainer.removeClass('playing');
                });
            });

            $('#btn-infooverlay').on('click', function (e) {
                e.preventDefault();
                $('body').addClass('infooverlayactive');
                $('#infooverlay').show();
            });

            $('#infooverlay').on('click', function (e) {
                $('body').removeClass('infooverlayactive');
                $('#infooverlay').hide();
            });

            $('.shareme a').on('click', function (e) {
                $(this).addClass('clicked');
            });
        });
    });

    jQuery(function ($) {
        $(document).ready(function () {
            let videoElement = $('.ct_petvideo.showcase video');
            if (videoElement && videoElement.length) {
                var videoPlayer = videoElement[0];

                videoElement.bind('ended', function () {
                    videoPlayer.removeAttribute('controls');
                    location.reload();
                });

                setTimeout(function () {
                    location.reload();
                }, 60000);
            }
        });
    });
}

window.UpdateThumbnail = function (target, upload, thumbnails) {
    let imageSrc = false;
    if (jQuery(thumbnails + ' input').is(':checked')) {
        let selectedRadio = jQuery(thumbnails + ' input:checked');
        imageSrc = selectedRadio.closest('.form-check').find('img').attr('src');
    } else {
        imageSrc = jQuery(upload + ' .wsf-dropzonejs-preview img').attr('src');
    }

    let preview = jQuery(target + ' div');
    if (imageSrc) {
        preview.html('<img src="' + imageSrc + '" alt="" />');
    } else {
        preview.html('<div class="empty"></div>');
    }
};
